import React from 'react';
import LetsGetStartedContent from './content';
import { LetsGetStartedProvider } from 'contexts/lets-get-started.context';

const LetsGetStartedLayout = () => {
  return (
    <LetsGetStartedProvider>
      <LetsGetStartedContent />
    </LetsGetStartedProvider>
  );
};

export default LetsGetStartedLayout;
